import colors from "../../base/colors";
import borders from "../../base/borders";

const { white } = colors;
const { borderWidth, borderRadius } = borders;

const card = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[1]} solid #d9d9d1`,
      borderRadius: borderRadius.xl,
      boxShadow: "none",
    },
  },
};

export default card;
